import React from 'react';
import Loging from '../page/Loging/Loging';

function LogingForm() {
  return <Loging />;
}

export default LogingForm;
